import { Grid } from '@domain-group/suit-theme'

import useSelector from '@hooks/useSelector'

import ImageWithStatusBadge from '../ImageWithStatusBadge'

const gridTemplateColumns = {
  large: 'repeat(2, 1fr)',
  small: 'repeat(3, 1fr)',
}

interface ImageGridProps {
  showIdCode?: boolean,
  specifiedImageIds: number[],
  viewMode: 'small' | 'large',
}

const ImageGrid = (props: ImageGridProps) => {
  const { specifiedImageIds, showIdCode, viewMode } = props

  const images = useSelector(reduxState => reduxState.entities.images)

  return (
    <Grid
      // @ts-expect-error TS2322
      gridGap="medium"
      gridTemplateColumns={gridTemplateColumns[viewMode]}
      padding="large"
    >
      {specifiedImageIds.map((imageId: number) => {
        const image = images[imageId] || {}

        return <ImageWithStatusBadge image={image} showIdCode={showIdCode} />
      })}
    </Grid>
  )
}

export default ImageGrid
